module.exports = __webpack_public_path__ + "img/adm4.fb45f9ba.png";